import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, TextField, Autocomplete, CircularProgress, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
// import MyTable from '../../components/Schedule/MyTable';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './resource-assign.css'
import { Link } from "react-router-dom";
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';

const ScheduleOverride = () => {
    const { user } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [scheduleList, setScheduleList] = useState([]);
    const [listType, setListType] = useState('Schedule Override');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [date, setDate] = useState('');
    const [deleteModal, setDeleteModal] = useState(false)
    const [rejectReason, setRejectReason] = useState('')
    const [shiftDate, setShiftDate] = useState('')
    const [shiftCode, setShiftCode] = useState('')
    const [empCode, setEmpCode] = useState('')

    const columns = [
        {
            field: 'Shift_Date', headerName: 'Shift Date', flex: 1, minWidth: 100,
            valueGetter: (params) => { return moment(params?.row?.Shift_Date).format('MM/DD/YY') }
        },

        {
            field: 'Member', headerName: 'Member', flex: 1, minWidth: 160, valueGetter: (params) => params?.row?.employee?.fullName
        },

        {
            field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 130,
            renderCell: (params) => {
                return (
                    <Chip style={{ width: '60px' }}
                        label={params?.row?.shift?.Shift}
                        className={params?.row?.shift?.Shift_Code == 2 ? 'day-chip' : 'night-chip'} />
                )
            }
        },

        {
            field: 'Reassigned_Position', headerName: 'Reassigned Position (From → To)', flex: 1, minWidth: 360,
            renderCell: (params) => {
                return (<>
                    <Chip
                        label={params?.row?.employee_old_assignment?.position?.SO_Desc}
                        className='from-chip' />

                    <div className='chip-arrow'> → </div>

                    <Chip
                        label={params?.row?.position?.SO_Desc || 'NA'}
                        className='re-assign-to-chip' />
                </>)
            }
        },

        {
            field: 'Assignment_Change', headerName: 'Assignment (From → To)', flex: 1, minWidth: 340,
            renderCell: (params) => {
                return (<>
                    <Chip
                        label={params?.row?.employee_old_assignment?.assignment?.SO_Desc}
                        className='from-chip' />

                    <div className='chip-arrow'> → </div>

                    <Chip
                        label={params?.row?.assignment?.SO_Desc || 'NA'}
                        className='assign-to-chip' />
                </>)
            }
        },

        {
            field: 'Create_Time', headerName: 'Create Time', flex: 1, minWidth: 200,
            valueGetter: (params) => { return varFormatTime(params?.row?.Create_Time, user?.Time_Format) }
        },
        {
            field: 'action', headerName: 'Actions', flex: 1, maxWidth: 130,minWidth:100,
            renderCell: (params) => {
							  const shiftDate = new Date(params?.row?.Shift_Date);
        				const today = new Date();
								// const showDelete = moment(shiftDate).startOf('day').isSameOrAfter(moment().startOf('day'));
								// const showDelete = moment(shiftDate).format('MM/DD/YYYY') >= moment(today).format('MM/DD/YYYY');
                const showDelete = moment(params.row.Shift_Date).isSameOrAfter(moment(), 'day');
								return (
                    <Box sx={{ display: 'flex', gap: 1 }}>
											{showDelete &&(
                        <img src='/images/delete.svg' style={{ cursor: 'pointer' }}
                            onClick={() => {
                                setEmpCode(params?.row?.Emp_Code)
                                setShiftDate(params?.row?.Shift_Date)
                                setShiftCode(params?.row?.Shift_Code)
                                setDeleteModal(true)
                            }}
                        />
												)}
                    </Box>
                );
            },
        }
    ]

    const getScheduleList = (loader = true) => {
        const body = {
            'date': date != '' ? moment(date).format('MM/DD/YYYY') : date,
        }
        if (loader) {
            setLoading(true);
        }
        ApiService.post('/ra/schedule-override?page=' + currentPage, body)
            .then((data) => {
                setScheduleList(data?.data);
                setTotalPages(Math.ceil(data?.total / data?.per_page));
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    };

		// const processedScheduleList = scheduleList.map(row => ({
		// 	...row,
		// 	id: row.id || `${row.Shift_Date}-${row.Shift_Code}-${row.Emp_Code}`
		// }));

    const handlePageChange = (_, value) => {
        setCurrentPage(value);
    };

    const deleteSchedule = () => {
        const body = {
            'EmpCode': empCode,
            'ShiftDate': shiftDate,
            'ShiftCode': shiftCode,
            'Comment': rejectReason
        }
        ApiService.post('/deleteEmployeeeSchedule', body)
            .then((data) => {
                setRejectReason('')
                setDeleteModal(false)
                toast.success(data?.message)
                getScheduleList()
            })
            .catch((err) => {
                toast.error(err?.data?.message)
            })
    }

		// const downloadSchedule = () => {

		// 	ApiService.post('/exportEmployeeeScheduleReport')
		// 		.then((data) => {
		// 				toast.success(data?.message)
		// 		})
		// 		.catch((err) => {
		// 				toast.error(err?.data?.message)
		// 		})
    // }
const firehouseApiUrl = (window.location.host == "v3-staging.firehouse247.com")?process.env.REACT_APP_FIREHOUSE_API_URL_STAGING : process.env.REACT_APP_FIREHOUSE_API_URL;

		const getUrlPrefix = () => {
  const department = localStorage.getItem('department');

  return `https://${department}.${firehouseApiUrl}`;
};

		 const downloadSchedule = async () => {
    try {
      const response = await fetch(getUrlPrefix() + '/exportEmployeeeScheduleReport', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.9',
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'Content-Type': 'type/csv',
        },
        body: JSON.stringify({ responseType: 'blob' }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const blob = await response.blob();

      // Create a link and trigger download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'employee_schedule.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

    useEffect(() => {
        getScheduleList()
    }, [currentPage, date])

    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            ) :
                (
                    <>
                        <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                            <Grid container spacing={2} className='align-items-center'>

                                {/* Heading */}
                                <Grid item xs={10} md={4}>
                                    <Typography variant="h5">Schedule Override</Typography>
                                </Grid>

                                {/* Schedule Override Button */}
                                <Grid item xs={6} sm={6} md={'auto'}>
                                    <Link to='/firehouse/schedule-override' style={{ textDecoration: 'none' }}>
                                        <div className={listType == 'Schedule Override' ? 'tab-active px-4' : 'tab-white px-4'}
                                            onClick={() => setListType('Schedule Override')}>
                                            Schedule Override
                                        </div>
                                    </Link>
                                </Grid>

                                {/* Resource Assignment Button */}
                                <Grid item xs={6} sm={6} md={'auto'}>
                                    <Link to='/firehouse/resource-assignment' style={{ textDecoration: 'none' }}>
                                        <div className={listType == 'Resource Assignment' ? 'tab-active px-4' : 'tab-white px-4'}
                                            onClick={() => setListType('Resource Assignment')}>
                                            Resource Assignment
                                        </div>
                                    </Link>
                                </Grid>


                                {/* Export Csv */}
                                <Grid item xs={12} sm={6} md={3} className='d-flex' style={{ marginLeft: 'auto', marginRight: '20px', justifyContent: 'end' }}>
																<ButtonTheme type="submit"
																				variant="filled" color="primary" 
																				onClick = {downloadSchedule} 
																		>
																				Export Report
																</ButtonTheme>
                                </Grid>

                            </Grid>

                            {(!scheduleList || scheduleList.length == 0) ?
                                <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 595 }}>
                                    <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                                    <span className='mt-4' style={{ color: '#555555' }}>
                                        No schedule override
                                    </span>
                                </div>
                                :
                                <>
                                    <div className='mt-4'>
                                        {/* <MyTable
                                            rows={scheduleList}
                                            columns={columns}
                                            checkboxSelection={false}
                                            hideFooter={true}
                                        /> */}

																					<DataGrid
																						rows={scheduleList}
																						columns={columns}
																						checkboxSelection={false}
																						hideFooter={true}
																						sx={{
																							"& .MuiDataGrid-columnHeaderTitleContainer": {
																								display: "flex !important",
																							},
																							"& .MuiTablePagination-selectLabel": {
																								marginBottom: "0 !important"
																							},
																							"& .MuiTablePagination-displayedRows": {
																								marginBottom: "0 !important"
																							},
																							"& .MuiDataGrid-columnHeader": {
																								minWidth: "100px",
																							},
																						}}
																					/>
                                    </div>

                                    <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                        className="mt-4 d-flex"
                                        style={{ justifyContent: 'end' }}
                                    />
                                </>
                            }
                            {/* Delete Modal */}
                            <Modal show={deleteModal} size="md"
                                onHide={() => { setDeleteModal(false) }}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Delete Schedule</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
                                        <div className="p-0" style={{ color: '#555555', marginBottom: '12px' }}>
                                            Enter the reason to delete this schedule
                                        </div>
                                        <Col md={12} className="p-0">
                                            <TextField
                                                className='mt-1 w-100'
                                                multiline
                                                color='secondary'
                                                variant="outlined"
                                                value={rejectReason}
                                                placeholder="Enter Reason"
                                                sx={{
                                                    // "& .MuiInputBase-root": {
                                                    //   minHeight: '100px',
                                                    //   maxHeight: '150px',
                                                    // },
                                                    "& .MuiInputBase-input": {
                                                        // position: 'absolute',
                                                        // top: '13px',
                                                        // left: '12px',
                                                        minHeight: '150px',
                                                        maxHeight: '150px',
                                                        overflow: 'scroll !important',
                                                    }
                                                }}
                                                onChange={(e) => setRejectReason(e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-3'
                                        onClick={() => deleteSchedule()}
                                    >
                                        Submit
                                    </ButtonTheme>
                                </Modal.Body>
                            </Modal>

                        </Paper>
                    </>
                )
            }
        </>
    )
}

export default ScheduleOverride